<template>
  <section>
    <div class="payment__done">
      <div class="info">
        <div class="error_box">
          <p v-html="msg"></p>

          <!-- <p>state => {{ state }}</p>
          <p>code => {{ code }}</p>
          <p>oauth_token => {{ oauth_token }}</p>
          <p>e1 => {{ e1 }}</p>
          <p>dosi_token => {{ dosi_token }}</p>
          <p>dosi_profile_id => {{ dosi_profile_id }}</p>
          <p>dosi_nft_list => {{ dosi_nft_list }}</p> -->
        </div>
        
        <div class="link_box">
            <button class="btn" @click="back">확인</button>
        </div>
      </div>
      
    </div>
    

    <loading v-show="loading"/>
  </section>
</template>

<script>
import { useRoute } from 'vue-router'
import client from "../client/client";
import Loading from '../components/Loading'

export default {
  name: 'CallbackDosi',
  components: {
    Loading,
  },
  data() {
    const route = useRoute()
    const { query } = route;
    return {
      msg:'연동 진행중 입니다',
      loading: true,
      dosi_token: null,
      code: 'dd',
      state:'member_no',
      dosi_profile_id: null,
      e1: null,
      dosi_nft_list: null,
      oauth_token: 'ddd',
      deviceType: '',
    };
  },
  methods: {
    adjustHeight() {
      console.log('asdfadsf');
      const vh = window.innerHeight;
      console.log(window.innerHeight);
      console.log('vh => ', vh);
      document.documentElement.style.setProperty('--app-height', `${vh}px`);
    },
    checkDeviceType() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      console.log('userAgent => ', userAgent);

      if (/android/i.test(userAgent)) {
        this.deviceType = 'Android';
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.deviceType = 'iOS';
      } else {
        this.deviceType = 'Unknown';
      }
    },
    async update() {
      const route = useRoute()
      const { query } = route;
      client.updateToken(query);
      const code = query.code;
      const state = query.state;
      this.state = state;
      this.code = code;
      if (!code) {
        this.loading = false;
        this.msg = '연동이 실패하였습니다.'
        throw new Error('Authorization code is missing');
      }

      if (!state){
        this.loading = false;
        this.msg = '연동이 실패하였습니다.'
        throw new Error('Authorization state is missing');
      }
      

      try {
        let res = await client.post('/api/dosi/oauth', {code});
        if (res && res.r) {
          this.oauth_token = res.result.response_body.access_token;
          let check_nft = await client.post('/api/dosi/check/nft', { access_token: this.oauth_token});
          if (check_nft && check_nft.r) {
            let dosi_profile = await client.post('/api/dosi/profile', { member_no: this.state, access_token: this.oauth_token, nft_number: check_nft && check_nft.list ? check_nft.list.length : 0});
            // tset로 nft_number 3개라고 가정
            // let dosi_profile = await client.post('/api/dosi/profile', { access_token: res.access_token, nft_number: 3});
            if (dosi_profile && dosi_profile.r && dosi_profile.profile_id) {
              this.dosi_token = this.oauth_token;
              this.dosi_profile_id = dosi_profile.profile_id;
              this.msg = `연동이 완료되었습니다. `;
              this.loading = false; // 성공 시 로딩 상태를 false로 설정
            } else {
              this.loading = false; // 실패 시 로딩 상태를 false로 설정
              this.msg = `${dosi_profile && dosi_profile.msg ? dosi_profile.msg : '연동이 실패하였습니다.'}`;
              this.msg = this.msg.replace(/\n/g, '<br>');
            }
          } else {
            this.loading = false; // 실패 시 로딩 상태를 false로 설정
            this.msg = check_nft && check_nft.msg ? check_nft.msg : '연동이 실패하였습니다.';
            this.msg = this.msg.replace(/\n/g, '<br>');
          }
        } else {
          this.msg = res && res.msg ? res.msg : '연동이 실패하였습니다.';
        }
      } catch (error) {
        const errorInfo = {
          message: error.message,
          code: error.code,
          config: {
            url: error.config?.url,
            method: error.config?.method,
            data: error.config?.data,
          },
          response: {
            status: error.response?.status,
            statusText: error.response?.statusText,
            headers: error.response?.headers,
          },
        };
        
        const e1 = JSON.stringify(errorInfo, null, 2);

        this.e1 = e1;
        this.msg = '연동 중 에러가 발생하였습니다.';
        console.error('Error during authentication:', error);
      } finally {
        this.loading = false;
      }
    },
    back(event){
      event.preventDefault(); // 기본 동작 방지
      let url = `https://todaymeal.page.link/DOSI`;
      // if(this.dosi_token)
      //   url += `?dosi_token=${this.dosi_token}`;

      if(this.deviceType == 'iOS') {
        url = 'jevil://devil.com/rootScreen/main';
      }
      window.location.href = url;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustHeight);
  },
  async mounted() {
    this.checkDeviceType();
    this.update();
    this.adjustHeight();
    window.addEventListener('resize', this.adjustHeight);
  },
};
</script>

<style lang="scss" scoped>
body, html {
  overflow: hidden;
  height: var(--app-height); /* 동적으로 계산된 높이 사용 */
}
section {
  overflow: hidden;
  height: var(--app-height); /* 수정됨 */
}
.payment__done {
  overflow: hidden;
  display: flex;
  width: 100%;
  margin: 0 auto;
  height: var(--app-height); /* 수정됨 */
  align-items: center;
  justify-content: center;
  background: #F4F4F4;
  .info {
    text-align: center;
    p {
      font-size: 16px;
      color: #343434;
      margin: 0;
      padding: 0 0 20px;
    }
    button {
      width: 130px;
      line-height: 52px;
      text-align: center;
      border-radius: 8px;
      font-size: 16px;
      font-weight: bold;
      &:first-child {
        border: 1px solid #F2632A;
        background: #fff;
        color: #F2632A;
        margin-right: 8px;
      }
      &:last-child {
        border: 1px solid #F2632A;
        background: #F2632A;
        color: #fff;
        margin-left: 8px;
      }
    }
  }
}
</style>